class Send_Email {
    static path = 'email-actions/send-email';
    static vueMethods = {
        'triggerEmailCompose': ({subject, body, sendEmail}) => {
            window.VueApp.$modal.show('send-email-action');
        },
        'saveEmailCompose': ({subject, body, sendEmail}) => {
            sendEmail.properties.subject = subject
            sendEmail.properties.body = body
            window.VueApp.$modal.hide('send-email-action');
        }
    }

    constructor(mutator){
        this.addInput("Determining Condition", "boolean");
        this.addInput("Email or User", "email,user");
        this.addInput("Other Data", "");
        this.bgcolor = '#00d1b2';
        this.title = 'Send Email';
        this.desc = 'Sends an email to the given email address.';
        this.properties = {
            subject: 'Example: Hey {{ $d[\'username\'] }}! Here is an automated alert.',
            body: '# This is a sample HEADER (Made possible by the pound-sign + space)\n' +
                '## This is a sub-header (Made possible by the double pound-sign + space)... etc. \n' +
                'This uses the "markdown" styling style. Google it!\n\n' +
                'Example Email: \n' +
                'Hey {{ $d[\'addressee\'] }},\n' +
                'This automated email was generated to let you know that {{ $e[\'title\'] }} was updated! \n\n' +
                '@component(\'mail::panel\')\n' +
                'This is a sample panel\n' +
                'New Title: {{ $e[\'title\'] }}\n' +
                'Managers: {{ $e[\'title\'] }}\n' +
                '@endcomponent'
        };

        let sendEmailSelf = this;
        if(window.VueApp.container.graphStatus !== 'read_only') {
            this.addWidget("button", "Compose Email", null, (v) => {
                window.VueApp.$refs.triggerBuilder.runNodeMethod('triggerEmailCompose', {
                    bucket1: this.properties.subject,
                    bucket2: this.properties.body,
                    node: sendEmailSelf
                }, true);
            });
        }
    }



}

module.exports = Send_Email
